import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { useAdyen } from "../../../../context/Adyen/context/Adyen/context.js";
function useCheckout(onChange) {
  const { locale } = useIntl();
  const { AdyenModule, clientKey, environment } = useAdyen();
  const options = React.useMemo(
    () => ({
      clientKey,
      environment,
      locale: `${locale}`,
      onChange
    }),
    [clientKey, environment, locale, onChange]
  );
  const checkout = React.useMemo(() => {
    const AdyenCheckout = AdyenModule?.result;
    return AdyenCheckout && AdyenCheckout(options);
  }, [AdyenModule, options]);
  return checkout;
}
export {
  useCheckout as default
};
//# sourceMappingURL=useCheckout.js.map
